import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Buyer, BuyersService } from 'src/app/core/buyers.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';

@Component({
  selector: 'app-buyers-confirm-otp-dialog',
  templateUrl: './buyers-confirm-otp-dialog.component.html',
  styleUrls: ['./buyers-confirm-otp-dialog.component.scss'],
})
export class BuyersConfirmOtpDialogComponent {
  buyer?: Buyer;
  confirm_otp_form_group = this.form_service.buyers_confirm_otp_form_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;
  is_confirming_otp_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<BuyersConfirmOtpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private form_service: FormService,
    private buyers_service: BuyersService,
  ) {
    this.buyer = data.buyer;
  }

  ngOnInit(): void {
    this.confirm_otp_form_group.get(this.form_service.confirm_reason_label)?.setValue(this.buyer?.confirm_reason || '');
  }

  isFormValid(): boolean {
    return this.form_service.validateForm(this.confirm_otp_form_group);
  }

  onSetNoteClick(): void {
    if (this.isFormValid() && this.buyer?.buyer_id) {
      this.is_confirming_otp_running = true;

      this.buyers_service
        .confirmByAdmin(
          this.buyer.buyer_id,
          this.confirm_otp_form_group.get(this.form_service.confirm_reason_label)?.value,
        )
        .subscribe({
          next: () => {
            this.dialog_ref.close({ success: true });
            this.is_confirming_otp_running = false;
          },
          error: error => {
            this.dialog_ref.close({ error });
            this.is_confirming_otp_running = false;
          },
        });
    }
  }
}
